define('casino/providers/Yggdrasil',['jquery'], function($) {
    'use strict';

    function Yggdrasil(casino, gameFunctions) {
        if (!(this instanceof Yggdrasil)) {
            throw new TypeError('Yggdrasil constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(yggdrasil, game, options) {
        yggdrasil.gameFunctions.showHelpButton();
        var provider = yggdrasil.casino.getProvider(game);

		if (yggdrasil.casino.getLocation() == 'GB')
			var src = provider.urlDemoUk;
		else
			var src = provider.urlDemo;


        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'YGG') {
            throw new Error('Illegal game code not starting with YGG: ' + game.code);
        }

        var $gameHolder = options.gameHolder;

        var $game = $gameHolder.find('.game');
        $game.empty();

        src += $.param({
            gameid: game.publishCode,
            lang: game.language,
            curr: 'SEK',
            org:'Demo',
            channel:'pc',
            wmode: 'transparent',
            key:''
        });

        yggdrasil.gameFunctions.switchToFreeMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
    }

    function realMode(yggdrasil, game, options, data) {
        yggdrasil.gameFunctions.showHelpButton();
        var provider = yggdrasil.casino.getProvider(game);

		if (yggdrasil.casino.getLocation() == 'GB')
			var src = provider.urlUk;
		else
			var src = provider.url;

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'YGG') {
            throw new Error('Illegal game code not starting with YGG: ' + game.code);
        }

        var $gameHolder = options.gameHolder;

        var $game = $gameHolder.find('.game');
        $game.empty();

        src += $.param({
            gameid: game.publishCode,
            lang: game.language,
            curr: data.currency,
            org: data.siteCode,
            channel:'pc',
            wmode: 'transparent',
            key:data.sessionId,
			reminderInterval: 0
        });

        yggdrasil.gameFunctions.switchToRealMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
        yggdrasil.gameFunctions.verifyCurrency(data.currency);
    }

    Yggdrasil.prototype = {
        constructor: Yggdrasil,
        freeMode: function(game, options) { freeMode(this, game, options); },
        realMode: function(game, options, data) { realMode(this, game, options, data); }
    };

    return Yggdrasil;
});

